import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

const styles: Record<string, CSSProperties> = {
  container: {
    color: '#333',
    padding: '40px 20px',
    margin: '0 auto',
    maxWidth: 480,
    fontSize: 16,
    lineHeight: 1.6,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: '32px 24px',
    textAlign: 'center',
    width: '100%',
    maxWidth: 360,
  },
  icon: {
    fontSize: 48,
    marginBottom: 16,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 12,
    color: '#333',
  },
  message: {
    fontSize: 16,
    color: '#666',
    lineHeight: 1.5,
    marginBottom: 24,
  },
  notes: {
    fontSize: 13,
    color: '#999',
    lineHeight: 1.4,
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    border: '1px solid #e9ecef',
  },
}

export default function ThankYouMessage() {
  const { t } = useTranslation('common')
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>✅</div>
        <h2 style={styles.title}>{t('thank_you.title')}</h2>
        <p style={styles.message}>{t('thank_you.message')}</p>
        <div style={styles.notes}>
          {t('thank_you.note_adjustment')}
          <br />
          {t('thank_you.note_reference')}
        </div>
      </div>
    </div>
  )
}
